import '../styles/section-subtitle.css'

const SectionSubtitle = ({children}) => {
  return (
    <div className='section-subtitle'>{children}</div>
  )
}

export default SectionSubtitle